export const RequestState = {
    EMPTY: 'EMPTY',
    PENDING: 'PENDING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
  };
  